import Lenis from "@studio-freight/lenis";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { initHoloEffect } from "./card.js";
import { initDvdBounce, initFooterReveal } from "./footer.js";
import { initLoader } from "./preloader.js";
import { initManifiesto } from "./text.js";

gsap.registerPlugin(ScrollTrigger);

// ========================================
// 1. SETUP LENIS (solo desktop)
// ========================================
const isMobile = window.matchMedia("(pointer: coarse)").matches;

let lenis = null;

if (!isMobile) {
  lenis = new Lenis({
    duration: 1.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    smooth: true,
  });

  lenis.on("scroll", ScrollTrigger.update);

  gsap.ticker.add((time) => {
    lenis.raf(time * 1000);
  });

  gsap.ticker.lagSmoothing(0);

  // Bloquear scroll hasta que el loader termine
  lenis.stop();
} else {
  // En móvil, ScrollTrigger escucha el scroll nativo directamente
  ScrollTrigger.scrollerProxy(document.body, {
    scrollTop(value) {
      if (arguments.length) window.scrollTo(0, value);
      return window.scrollY;
    },
    getBoundingClientRect() {
      return {
        top: 0,
        left: 0,
        width: window.innerWidth,
        height: window.innerHeight,
      };
    },
  });

  window.addEventListener("scroll", ScrollTrigger.update, { passive: true });
}

// ========================================
// 2. INIT FUNCIONES QUE NO DEPENDEN DEL LOADER
// ========================================
function initApp() {
  const card = document.querySelector("#card");
  if (card) initHoloEffect("#card");

  const footer = document.querySelector(".footer");
  if (footer) {
    initDvdBounce(footer);
    initFooterReveal();
  }
}

// ========================================
// 3. INIT FUNCIONES QUE DEPENDEN DEL SCROLL
// ========================================
function initScrollAnimations() {
  initManifiesto();
  ScrollTrigger.refresh();
}

// ========================================
// 4. SECUENCIA DE INICIALIZACIÓN
// ========================================
initApp();

// El loader recibe null en móvil — asegúrate de que initLoader lo maneje
initLoader(lenis, () => {
  initScrollAnimations();
});

// ========================================
// 5. REFRESH GLOBAL AL CARGAR TODO
// ========================================
window.addEventListener("load", () => {
  setTimeout(() => {
    ScrollTrigger.refresh();
  }, 100);
});

// ========================================
// 6. REFRESH EN RESIZE
// ========================================
let resizeTimer;
window.addEventListener("resize", () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    ScrollTrigger.refresh();
  }, 250);
});
